import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import MyProgressDashboard from './MyProgressDashboard'
import CompanyDashboard from './CompanyDashboard'
import SettingsDashboard from './SettingsDashboard'

import './styles.scss'

const bc = 'dashboard'

const TEAM_DASHBOARD = 'My Progress'
const COMPANY_DASHBOARD = 'Company'
const SETTINGS = 'Settings'

class UserBoardMain extends Component {
  state = {
    myTeamDashoard: true,
    companyDashboard: false,
  }

  selectDashboard = title => {
    this.setState({
      myTeamDashoard: title === TEAM_DASHBOARD,
      companyDashboard: title === COMPANY_DASHBOARD,
      settings: title === SETTINGS,
    })
  }

  setComponentsHeight = id => {
    const el = document.getElementById(id)
    if (el) {
      this.props.setHeight(el.clientHeight)
    }
  }

  userBoardMenuItem = (isDashboardSelected, title, flag) => {
    const baseMenuItemClass = 'dashboard-menu-item'
    return (
      <span
        onClick={() => this.selectDashboard(title)}
        className={isDashboardSelected ? `${baseMenuItemClass} selected` : `${baseMenuItemClass}`}
        id={`${baseMenuItemClass}_${flag}`}
      >
        {this.props.t(title)}
      </span>
    )
  }

  render() {
    const { myTeamDashoard, companyDashboard, settings } = this.state

    return (
      <div className={bc} id={bc}>
        <div className={`${bc}-menu`}>
          {this.userBoardMenuItem(myTeamDashoard, TEAM_DASHBOARD, 'team')}
          {this.userBoardMenuItem(companyDashboard, COMPANY_DASHBOARD, 'company')}
          {this.userBoardMenuItem(settings, SETTINGS, 'settings')}
        </div>
        {myTeamDashoard && <MyProgressDashboard setComponentsHeight={this.setComponentsHeight} />}
        {companyDashboard && <CompanyDashboard setComponentsHeight={this.setComponentsHeight} />}
        {settings && <SettingsDashboard setComponentsHeight={this.setComponentsHeight} />}
      </div>
    )
  }
}

export default withTranslation('user')(UserBoardMain)
